import React from 'react';
import style from './index.module.css';

type Props = {
    onChange?: () => void;
    label?: string;
    checked?: boolean;
    disabled?: boolean;
};

const Checkbox = ({ label, checked, onChange, disabled }: Props) => (
    <label className={`${style.label} ${disabled ? style.disabled : ''}`}>
        {label}
        <input
            className={style.checkboxInput}
            type="checkbox"
            onChange={onChange}
            checked={checked}
            disabled={disabled}
        />
        <span className={style.checkmark}></span>
    </label>
);
export default Checkbox;
